import { MAX_WIDTH } from "@/utilities";
import { useMediaQuery } from "@mui/material";

export default function useIsMobile() {
    const matches = useMediaQuery(`(max-width:${MAX_WIDTH}px)`);
    return matches
}